import axios from "axios";

const apiServices = axios.create();
let isUnauthorizedHandled = false;

const logoutOnUnauthorized = () => {
    try {
        sessionStorage.clear();
    } catch (_) {
    }
    try {
        if (window?.location?.pathname !== "/") {
            isUnauthorizedHandled = true;
            window.location.href = "/";
        }
    } catch (_) {
    }
};

// Request interceptor
apiServices.interceptors.request.use(
    (config) => {
        try {
            const token = sessionStorage.getItem("_ac");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
        } catch (_) {
            
        }
        return config;
    },
    (error) => {
        return error;
    }
);

// Response interceptor
apiServices.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const statusCode = error?.response?.status;
        if (statusCode === 401 && !isUnauthorizedHandled) {
            logoutOnUnauthorized();
        }
        return Promise.reject(error);
    }
);

export {
    apiServices,
};
